import { gate } from 'hub-http/gates';
export const EVENT_ENROLLMENT_INTEGRATOR_EVENTS = 'automation:eventenrollment:integratorevents';
export const DEAL_OBJECT_LISTS = 'CRM:Segments:DealListsCreation';
export const AI_GENERATED_WORKFLOWS = 'Automation:AIGeneratedWorkflows';
export const ENFORCE_FIELD_LEVEL_PERMISSIONS = 'Automation:EnforceFieldLevelPermissions';
export const DATASET_BULK_ENROLLMENT = 'Automation:BulkEnrollFromDataset';
export const DATASET_FUNCTIONALITY = gate('DataStudio:BetaAccess');
export const PERMISSIONS_CUSTOM_EVENTS = gate('Permissions:CustomEvents');
export const INTERACTIVE_ACTION = gate('AutomationPlatform:InteractiveAction');
export const SUPPORT_SELECTING_SENSITIVE_PROPERTIES = gate('Automation:SupportSelectingSensitiveProperties');